var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25192 12C5.03997 12 4.8623 11.9281 4.71892 11.7844C4.57554 11.6406 4.50385 11.4625 4.50385 11.25V6.75L0.165017 1.2C-0.0220022 0.95 -0.050055 0.6875 0.0808581 0.4125C0.211771 0.1375 0.439311 0 0.763476 0H11.2365C11.5607 0 11.7882 0.1375 11.9191 0.4125C12.0501 0.6875 12.022 0.95 11.835 1.2L7.49615 6.75V11.25C7.49615 11.4625 7.42446 11.6406 7.28108 11.7844C7.1377 11.9281 6.96003 12 6.74807 12H5.25192ZM6 6.225L9.70297 1.5H2.29703L6 6.225Z",
    fill: "#27282B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6717f716a77a508a22d8a8a7e5ecd7c5.svg";
export { ForwardRef as ReactComponent };